import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './types';
import * as actions from './action';
import { approvalNotificationService } from './effect';


function* fetchApprovalNotificationsSaga(action) {
  try {
    const response = yield call(approvalNotificationService.getApprovalNotifications, action.payload);
    yield put(actions.fetchApprovalNotificationsSuccess(response));
  } catch (error) {
    yield put(actions.fetchApprovalNotificationsFailure(error.message));
  }
}


export function* approvalNotificationWatcher() {
  yield takeLatest(types.FETCH_APPROVAL_NOTIFICATIONS_REQUEST, fetchApprovalNotificationsSaga);
  
}
